// src/App.js
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import Header from './components/Header';
import HomePage from './pages/HomePage';
import RecipePage from './pages/RecipePage';
import StudyNotesPage from './pages/StudyNotesPage';
import StudyNoteDetail from './components/StudyNoteDetail'; // Make sure this import is correct

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/recipe/:id" element={<RecipePage />} />
          <Route path="/study-notes" element={<StudyNotesPage />} />
          <Route path="/study-notes/:id" element={<StudyNoteDetail />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;